import type { FunctionComponent } from 'react';
import * as T from './KindCompilationSlider.types';
import * as s from './KindCompilationSlider.css';
import Title from '@media-ui/core/src/components/Title';
import SliderNavigation from '../Slider/SliderNavigation';
import { baseSwiperConfig, sliderButtonJsClasses, } from './KindCompilationSlider.constants';
import Slider from '../Slider';
import { getAdaptedItems } from './KindCompilationSlider.utils';
import { IKindCompilationProps } from '../KindCompilation/KindCompilation.types';
import KindCompilation from '../KindCompilation/KindCompilation';
const KindCompilationSlider: FunctionComponent<T.IKindCompilationSliderProps> = (props) => {
    const { title, items } = props;
    return (<div>
      <header className={s.header}>
        {title && <Title level="2">{title}</Title>}
        <SliderNavigation className={s.sliderNavigation}>
          <SliderNavigation.Button className={sliderButtonJsClasses.prev} direction="prev"/>
          <SliderNavigation.Button className={sliderButtonJsClasses.next} direction="next"/>
        </SliderNavigation>
      </header>
      <Slider className={s.slider} items={getAdaptedItems(items)} renderContent={(props) => {
            const itemProps = props as IKindCompilationProps;
            return <KindCompilation {...itemProps}/>;
        }} swiperOptions={baseSwiperConfig}/>
    </div>);
};
export default KindCompilationSlider;
